/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-bitwise */
import { DocumentTypeCat } from '@ps/platform-message-framework/common/DocumentTypeCat';
import { addYears, isBefore } from 'date-fns';

import { Country } from '@swf/core/enums';

export const isDenmarkCitizen = (citizenship: string) =>
  citizenship === Country.Denmark || citizenship === Country.Greenland;

export const getGenderDK = (nationalDocumentNumber: string) =>
  +nationalDocumentNumber[9] % 2 === 0 ? 'F' : 'M';

export const generateExpiryDate = (
  issueDate: Date,
  documentType?: DocumentTypeCat,
  dateOfBirth?: Date
): Date => {
  let yearsToAdd = 10;
  if (documentType === DocumentTypeCat.DRIVERS_LICENSE) {
    const fiftyYrsDate = dateOfBirth && addYears(new Date(dateOfBirth), 50);
    yearsToAdd = isBefore(fiftyYrsDate as Date, new Date(issueDate)) ? 5 : 10;
  }
  return addYears(new Date(issueDate), yearsToAdd);
};

// https://github.com/FlutterInt/fips-shared-protocols/blob/master/lobby.h
const BROADCAST_REAL_MONEY = 0x2;

// https://github.com/FlutterInt/fips-poker-client/blob/68ac3e19f00a86aba6d443a0408fc3ee40e20ba4/gui/ChipsInfo.h#L63
export enum RMF_TRIGGER_POINT {
  TriggerPoint_Undef = 0,
  TriggerPoint_Deposit = BROADCAST_REAL_MONEY << 1,
  TriggerPoint_Cashout = BROADCAST_REAL_MONEY << 2,
  TriggerPoint_RMGames = BROADCAST_REAL_MONEY << 3,
  TriggerPoint_PendingFunds = BROADCAST_REAL_MONEY << 4,
  TriggerPoint_Menu = BROADCAST_REAL_MONEY << 5,
  TriggerPoint_C2L = BROADCAST_REAL_MONEY << 6,
  TriggerPoint_OnlineVerify = BROADCAST_REAL_MONEY << 7,
  TriggerPoint_SignUp3V = BROADCAST_REAL_MONEY << 8,
  TriggerPoint_RegisterStarsWallet = BROADCAST_REAL_MONEY << 9,
  TriggerPoint_MobileSignup = BROADCAST_REAL_MONEY << 10,
  TriggerPoint_MuchBetterSignup = BROADCAST_REAL_MONEY << 11,
  TriggerPoint_DataIntegrityCheck = BROADCAST_REAL_MONEY << 12,
  TriggerPoint_AccountCreation = BROADCAST_REAL_MONEY << 13,
  TriggerPoint_PlayerVerification = BROADCAST_REAL_MONEY << 14,
  TriggerPoint_ShowWebRGL = BROADCAST_REAL_MONEY << 15
}
